import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  SelectChangeEvent,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {Apartment} from 'src/apis/autoGenerate/types/apartment';
import SearchApartments from 'src/components/SearchApartment';
import {FilterBar} from 'src/components/ui';

export type DateRangePreset = 'all' | '7d' | '30d' | '90d';
export type EventTypeFilter = 'all' | 'door_open' | 'pin_access' | 'guest_access' | 'delivery';
export type StatusFilter = 'all' | 'success' | 'failed';

interface EventFilterBarProps {
  dateRange: DateRangePreset;
  onDateRangeChange: (value: DateRangePreset) => void;
  eventType: EventTypeFilter;
  onEventTypeChange: (value: EventTypeFilter) => void;
  statusFilter: StatusFilter;
  onStatusFilterChange: (value: StatusFilter) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onApartmentChange: (value: Apartment | null) => void;
}

export default function EventFilterBar({
  dateRange,
  onDateRangeChange,
  eventType,
  onEventTypeChange,
  statusFilter,
  onStatusFilterChange,
  searchQuery,
  onSearchChange,
  onApartmentChange,
}: EventFilterBarProps) {
  return (
    <FilterBar>
      <SearchApartments
        onChange={onApartmentChange}
        placeholder="Property"
        textFieldProps={{size: 'small'}}
      />

      <FormControl size="small" sx={{minWidth: 140}}>
        <InputLabel>Date Range</InputLabel>
        <Select
          value={dateRange}
          label="Date Range"
          onChange={(e: SelectChangeEvent) => onDateRangeChange(e.target.value as DateRangePreset)}
        >
          <MenuItem value="all">All Time</MenuItem>
          <MenuItem value="7d">Last 7 days</MenuItem>
          <MenuItem value="30d">Last 30 days</MenuItem>
          <MenuItem value="90d">Last 90 days</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{minWidth: 140}}>
        <InputLabel>Event Type</InputLabel>
        <Select
          value={eventType}
          label="Event Type"
          onChange={(e: SelectChangeEvent) =>
            onEventTypeChange(e.target.value as EventTypeFilter)
          }
        >
          <MenuItem value="all">All Events</MenuItem>
          <MenuItem value="door_open">Door Open</MenuItem>
          <MenuItem value="pin_access">Room PIN Access</MenuItem>
          <MenuItem value="guest_access">Guest Access</MenuItem>
          <MenuItem value="delivery">Delivery Access</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{minWidth: 120}}>
        <InputLabel>Status</InputLabel>
        <Select
          value={statusFilter}
          label="Status"
          onChange={(e: SelectChangeEvent) =>
            onStatusFilterChange(e.target.value as StatusFilter)
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="success">Success</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
        </Select>
      </FormControl>

      <TextField
        size="small"
        placeholder="Search name/device"
        value={searchQuery}
        onChange={e => onSearchChange(e.target.value)}
        sx={{minWidth: 200}}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{fontSize: 20, color: 'text.secondary'}} />
            </InputAdornment>
          ),
        }}
      />
    </FilterBar>
  );
}
